import { Eyes } from "./Eyes";
import arrowIcon from "../assets/images/arrow.svg";
import { HeaderBottom } from "./HeaderBottom";
import { useContext } from "react";
import { LocaleContext } from "../context/LocaleContext";
import { HireUs } from "./HireUs";

export const AffiliateTop = () => {
  const { t } = useContext(LocaleContext);
  
  return (
    <div
      className="home container"
      style={{ color: "#fff", minHeight: "100vh" }}
    >
      <Eyes />
      <span className="tagline">
        {t("Want to grow with us? ")}{" "}
        <span style={{ color: "#4cafc8", fontFamily: "HeadingFont" }}>
          {t("Earn 10% recurring revenue ")}
        </span>{" "}
        {t("for client referrals.")}
      </span>
      <div className="row-between">
        <HireUs text="Refer Us" />
        <span className="row-comment">
          <img src={arrowIcon} alt="->" className="arrow" />
          {t("Refer us and get recurring 10% of client's total budget.")}
        </span>
      </div>
      <HeaderBottom id={"affiliate"} />
    </div>
  );
};
